
import { store } from '../js/components/front/vue/store/store'
import Lang from '~/lang'
import { EventBus } from '../js/components/front/vue/Utils/event-bus'

window.timesync = require("timesync/dist/timesync")
// window.io = require('socket.io-client')

//Date.now support for older browsers
if (!Date.now) {
    Date.now = function () {
        return new Date().getTime()
    }
}

const pusher = Echo.connector.pusher || null

//const timesyncHost = process.env.MIX_SCHEDULE_QUEUE_URL;
const ts = timesync.create({
    server: process.env.MIX_TIMESYNC_HOST
});

let offset = 0
let serverDate = null
let debug = false
let initialRequest = true
let isReady = false
let syncInterval = null
let alertElm = null

if (pusher) {
    /*pusher.connection.bind('connected', () => {
        alertElm && Metro.dialog.close(alertElm)
    })*/

    pusher.connection.bind('state_change', function (states) {
        store.dispatch('setPusherConnexionState', states.current)

    });

    /*pusher.connection.bind('unavailable', () => {
        alertElm = Metro.dialog.create({
            title: Lang.get("javascript.socket.realtime_connexion_issue"),
            content: `
            <div>
                <p>${Lang.get("javascript.socket.connexion_unstable")}</p>
                <p>${Lang.get("javascript.socket.trying_to_connect")}</p>
                <p>${Lang.get("javascript.socket.check_your_connexion")}</p>
            </div>
            `,
            closeButton: true,
            onClose: () => {
                alertElm = null
                location.reload(true)
            }
        })
    })

    pusher.connection.bind('disconnected', () => {
        alertElm = Metro.dialog.create({
            title: Lang.get("javascript.socket.realtime_disconnected"),
            content: `
            <div>
                ${Lang.get("javascript.socket.page_will_reload")}
            </div>
            `,
            closeButton: true,
            onClose: () => {
                alertElm = null
                location.reload(true)
            }
        })

        setTimeout(() => location.reload(true), 10000)
    })*/

}

// get notified on changes in the offset
ts.on('change', (timeOffset) => {
    serverDate = ts.now();
    offset = timeOffset;

    if (initialRequest) {
        moment.now = () => {
            return now()
        }
        isReady = true
        initialRequest = false
    } else {
        EventBus.$emit('time-offset-changed')
    }

    store.dispatch('setSynchrinization', true)
});

ts.on("sync", function (state) {
})

function now () {
    return ts.now()
}

function ServerDate () {
    // See http://stackoverflow.com/a/18543216/1330099.
    return this
        ? ServerDate
        : ServerDate.toString()
}

ServerDate.debug = function (val) {
    if (val !== undefined) {
        debug = val
    } else {
        return debug
    }
}

ServerDate.parse = Date.parse
ServerDate.UTC = Date.UTC
ServerDate.now = function () {
    return now()
}
// Populate ServerDate with the methods of Date's instances that don't change
// state.
const methods = [
    'toString', 'toDateString', 'toTimeString', 'toLocaleString',
    'toLocaleDateString', 'toLocaleTimeString', 'valueOf', 'getTime',
    'getFullYear', 'getUTCFullYear', 'getMonth', 'getUTCMonth', 'getDate',
    'getUTCDate', 'getDay', 'getUTCDay', 'getHours', 'getUTCHours',
    'getMinutes', 'getUTCMinutes', 'getSeconds', 'getUTCSeconds',
    'getMilliseconds', 'getUTCMilliseconds', 'getTimezoneOffset', 'toUTCString',
    'toISOString', 'toJSON'
]

methods.forEach(function (method) {
    ServerDate[method] = function () {
        return new Date(ServerDate.now())[method]()
    }
})

Object.defineProperty(ServerDate, 'isReady', {
    set (value) {
        isReady = value
    },
    get () {
        return isReady
    }
})

window.ServerDate = ServerDate
